import axios from 'axios'
import router from '../router'
// import store from '../store/index'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset-utf-8'
const service = axios.create({
  baseURL: 'https://szshsurvey.com/',
  headers:{
  },
  // withCredentials: true,
  timeout: 60000 // request timeout
})
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    window.console.log('请求错误', error)
    return Promise.reject(new Error(error))
  }
)
service.interceptors.request.use(
  request => {
    request.headers.Tenant = '0' 
    return request 
  },
  error => {
    window.console.log('请求错误', error)
    return Promise.reject(new Error(error))
  }
)

export default { service }
